import { atom, useAtom } from 'jotai'

// refreshToken状态
export const refreshSocketAtom = atom<boolean>(false)
refreshSocketAtom.debugLabel = 'refreshSocketAtom'

export const hasUnreadMessageAtom = atom(false)
hasUnreadMessageAtom.debugLabel = 'hasUnreadMessageAtom'

export const connectionCloseAtom = atom(false)
connectionCloseAtom.debugLabel = 'connectionCloseAtom'

export function useMessageAtom() {
  // websocket连接是否关闭
  const [connectionClose, setConnectionClose] = useAtom(connectionCloseAtom)

  // 有未读消息
  const [hasUnreadMessage, setHasUnreadMessage] = useAtom(hasUnreadMessageAtom)

  return {
    hasUnreadMessage,
    setHasUnreadMessage,
    connectionClose,
    setConnectionClose,
  }
}
